<template>
  <div class="current-list">
    <ul class="list-box">
      <li class="list-item" v-for="(item, key) in curriculumData" :key="key" @click="playClock(item.mxTitle, item.mxVedio, item.mxId, item.olCurriculumStage, item.olCurriculumId)">
        <div class="item-img"><img :src="item.mxImg ? item.mxImg : item.olCurriculumImg" alt=""></div>
        <div class="list-content">
          <div class="item-describe">{{item.mxTitle ? item.mxTitle : item.olCurriculumName}}</div>
          <div class="item-type">
            <p>授课方式：录播</p>
            <p>{{item.num ? item.num : Math.ceil(Math.random()*1000)}}人学习</p>
          </div>
          <div class="item-start">免费</div>
        </div>
      </li>
    </ul>
    <!--    公开课页面播放-->
    <open-play v-if="openType" :src="src" :title="title"></open-play>
    <play-view v-if="playVisible && !openType" :src="src" :title="title" :mxId="mxId" :olCurriculumStage="olCurriculumStage"></play-view>
<!--     实名认证弹窗-->
    <el-dialog
      title="请前往APP进行实名认证"
      :visible.sync="realDialogVisible"
      width="400px">
      <div class="real-box">
        <div class="img-box">
          <img src="../assets/img/Android.png" alt="">
          <div>Android下载</div>
        </div>
        <div class="img-box">
          <img src="../assets/img/Android.png" alt="">
          <div>ios下载</div>
        </div>
      </div>
    </el-dialog>
    <!--     邀请码弹窗-->
    <el-dialog
      title="请输入邀请码"
      :visible.sync="inviteVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px">
      <el-form :model="inviteForm">
        <el-form-item label="邀请码" label-width="70px">
          <el-input v-model="inviteForm.invitationCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="inviteBtn">取 消</el-button>
        <el-button type="primary" @click="inviteBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import playView from './playView'
import openPlay from './openPlay'

export default {
  name: 'curList',
  props: ['curriculumData', 'openType'],
  computed: {
    ...mapState(['playVisible'])
  },
  components: {
    playView,
    openPlay
  },
  data () {
    return {
      dialogVisible: false,
      src: 'http://www.sxlihang.cn/third.mp4',
      title: '',
      mxId: '', // 课时id
      olCurriculumStage: '',
      olCurriculumId: '', //课程id
      //  展示视频页面
      showVideo: false,
      realDialogVisible: false,
      inviteVisible: false,
      inviteForm: {
        invitationCode: ''
      }
    }
  },
  mounted () {
    // console.log(this.curriculumData)
  },
  methods: {
    ...mapMutations(['setPlayVisible']),
    playClock (title, src, id, olCurriculumStage, olCurriculumId) {
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/sys/info',
      }).then(res=>{
        console.log(res)
        if (res.data.data.states == 2) {
          this.realDialogVisible = true
        } else {
          this.getInviteCode(olCurriculumId)
          this.title = title
          this.src = src
          this.mxId = id
          this.olCurriculumStage = olCurriculumStage
          this.olCurriculumId = olCurriculumId
        }
      })
    },
    // 获取是否存在邀请码
    getInviteCode(olCurriculumId) {
      this.$http({
        method: 'POST',
        url: '/api/renren-fast/app/olusertrain/checktrain',
        data: {
          olCurriculumId: olCurriculumId
        }
      }).then(res=>{
        // console.log(res)
        if (res.data.data) {
          this.inviteVisible=true
        } else {
          this.setPlayVisible(true)
        }
      })
    },
    // 提交邀请码确认
    inviteBtn() {
      this.$http({
        method: 'POST',
        url: '/api/renren-fast/app/olusertrain/savetrain',
        data: {
          olCurriculumId: this.olCurriculumId,
          invitationCode: this.inviteForm.invitationCode
        }
      }).then(res=>{
        this.inviteVisible=false
        this.setPlayVisible(true)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.list-box{
  display: flex;
  flex-wrap: wrap;
  .list-item{
    width: 265px;
    height: 282px;
    border: 1px solid #eee;
    cursor: pointer;
    margin: 0px 30px 20px 0px;
    .item-img{
      width: 263px;
      height: 159px;
      //overflow: hidden;
      //text-align: center;
      //border-bottom: 1px solid #eee;
      //line-height: 159px;
      img{
        //max-width: 263px;
        //max-height: 159px;
        width: 100%;
        height: 100%;
      }
    }
    .list-content{
      padding: 10px;
    }
    .item-describe{
      font-size: 18px;
      color: #333;
      line-height: 24px;
      height: 50px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .item-type{
      display: flex;
      justify-content: space-between;
      color: #999;
      margin: 10px 0px 5px 0px;
    }
    .item-start{
      font-size: 16px;
      color: #ce443a;
      font-weight: bold;
    }
  }
}
  .real-box{
    display: flex;
    .img-box{
      width: 50%;
      text-align: center;
      font-size: 12px;
      color: #333;
      margin-left: 15px;
      img{
        width: 120px;
        height: 120px;
        margin-bottom: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/curList.vue